// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__36pCl","footer":"ModalUpdate_footer__f300O"};